/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserUserProfileIndexRouteImport } from './routes/user/user-profile/index'
import { Route as SettingsUsersIndexRouteImport } from './routes/settings/users/index'
import { Route as SettingsSecurityIndexRouteImport } from './routes/settings/security/index'
import { Route as SettingsBanksIndexRouteImport } from './routes/settings/banks/index'
import { Route as SettingsAccountsIndexRouteImport } from './routes/settings/accounts/index'
import { Route as PaymentsSepaIndexRouteImport } from './routes/payments/sepa/index'
import { Route as PaymentsPairingIndexRouteImport } from './routes/payments/pairing/index'
import { Route as PaymentsForeignIndexRouteImport } from './routes/payments/foreign/index'
import { Route as PaymentsDomesticIndexRouteImport } from './routes/payments/domestic/index'
import { Route as SettingsUsersNewRouteImport } from './routes/settings/users/new'
import { Route as SettingsUsersIdRouteImport } from './routes/settings/users/$id'
import { Route as PaymentsSepaIdRouteImport } from './routes/payments/sepa/$id'
import { Route as PaymentsPairingIdRouteImport } from './routes/payments/pairing/$id'
import { Route as PaymentsForeignIdRouteImport } from './routes/payments/foreign/$id'
import { Route as PaymentsDomesticIdRouteImport } from './routes/payments/domestic/$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserProfileIndexRoute = UserUserProfileIndexRouteImport.update({
  id: '/user/user-profile/',
  path: '/user/user-profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUsersIndexRoute = SettingsUsersIndexRouteImport.update({
  id: '/settings/users/',
  path: '/settings/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSecurityIndexRoute = SettingsSecurityIndexRouteImport.update({
  id: '/settings/security/',
  path: '/settings/security/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBanksIndexRoute = SettingsBanksIndexRouteImport.update({
  id: '/settings/banks/',
  path: '/settings/banks/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountsIndexRoute = SettingsAccountsIndexRouteImport.update({
  id: '/settings/accounts/',
  path: '/settings/accounts/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsSepaIndexRoute = PaymentsSepaIndexRouteImport.update({
  id: '/payments/sepa/',
  path: '/payments/sepa/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsPairingIndexRoute = PaymentsPairingIndexRouteImport.update({
  id: '/payments/pairing/',
  path: '/payments/pairing/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsForeignIndexRoute = PaymentsForeignIndexRouteImport.update({
  id: '/payments/foreign/',
  path: '/payments/foreign/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsDomesticIndexRoute = PaymentsDomesticIndexRouteImport.update({
  id: '/payments/domestic/',
  path: '/payments/domestic/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUsersNewRoute = SettingsUsersNewRouteImport.update({
  id: '/settings/users/new',
  path: '/settings/users/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUsersIdRoute = SettingsUsersIdRouteImport.update({
  id: '/settings/users/$id',
  path: '/settings/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsSepaIdRoute = PaymentsSepaIdRouteImport.update({
  id: '/payments/sepa/$id',
  path: '/payments/sepa/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsPairingIdRoute = PaymentsPairingIdRouteImport.update({
  id: '/payments/pairing/$id',
  path: '/payments/pairing/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsForeignIdRoute = PaymentsForeignIdRouteImport.update({
  id: '/payments/foreign/$id',
  path: '/payments/foreign/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsDomesticIdRoute = PaymentsDomesticIdRouteImport.update({
  id: '/payments/domestic/$id',
  path: '/payments/domestic/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/payments/domestic/$id': typeof PaymentsDomesticIdRoute
  '/payments/foreign/$id': typeof PaymentsForeignIdRoute
  '/payments/pairing/$id': typeof PaymentsPairingIdRoute
  '/payments/sepa/$id': typeof PaymentsSepaIdRoute
  '/settings/users/$id': typeof SettingsUsersIdRoute
  '/settings/users/new': typeof SettingsUsersNewRoute
  '/payments/domestic': typeof PaymentsDomesticIndexRoute
  '/payments/foreign': typeof PaymentsForeignIndexRoute
  '/payments/pairing': typeof PaymentsPairingIndexRoute
  '/payments/sepa': typeof PaymentsSepaIndexRoute
  '/settings/accounts': typeof SettingsAccountsIndexRoute
  '/settings/banks': typeof SettingsBanksIndexRoute
  '/settings/security': typeof SettingsSecurityIndexRoute
  '/settings/users': typeof SettingsUsersIndexRoute
  '/user/user-profile': typeof UserUserProfileIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/payments/domestic/$id': typeof PaymentsDomesticIdRoute
  '/payments/foreign/$id': typeof PaymentsForeignIdRoute
  '/payments/pairing/$id': typeof PaymentsPairingIdRoute
  '/payments/sepa/$id': typeof PaymentsSepaIdRoute
  '/settings/users/$id': typeof SettingsUsersIdRoute
  '/settings/users/new': typeof SettingsUsersNewRoute
  '/payments/domestic': typeof PaymentsDomesticIndexRoute
  '/payments/foreign': typeof PaymentsForeignIndexRoute
  '/payments/pairing': typeof PaymentsPairingIndexRoute
  '/payments/sepa': typeof PaymentsSepaIndexRoute
  '/settings/accounts': typeof SettingsAccountsIndexRoute
  '/settings/banks': typeof SettingsBanksIndexRoute
  '/settings/security': typeof SettingsSecurityIndexRoute
  '/settings/users': typeof SettingsUsersIndexRoute
  '/user/user-profile': typeof UserUserProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/payments/domestic/$id': typeof PaymentsDomesticIdRoute
  '/payments/foreign/$id': typeof PaymentsForeignIdRoute
  '/payments/pairing/$id': typeof PaymentsPairingIdRoute
  '/payments/sepa/$id': typeof PaymentsSepaIdRoute
  '/settings/users/$id': typeof SettingsUsersIdRoute
  '/settings/users/new': typeof SettingsUsersNewRoute
  '/payments/domestic/': typeof PaymentsDomesticIndexRoute
  '/payments/foreign/': typeof PaymentsForeignIndexRoute
  '/payments/pairing/': typeof PaymentsPairingIndexRoute
  '/payments/sepa/': typeof PaymentsSepaIndexRoute
  '/settings/accounts/': typeof SettingsAccountsIndexRoute
  '/settings/banks/': typeof SettingsBanksIndexRoute
  '/settings/security/': typeof SettingsSecurityIndexRoute
  '/settings/users/': typeof SettingsUsersIndexRoute
  '/user/user-profile/': typeof UserUserProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/payments/domestic/$id'
    | '/payments/foreign/$id'
    | '/payments/pairing/$id'
    | '/payments/sepa/$id'
    | '/settings/users/$id'
    | '/settings/users/new'
    | '/payments/domestic'
    | '/payments/foreign'
    | '/payments/pairing'
    | '/payments/sepa'
    | '/settings/accounts'
    | '/settings/banks'
    | '/settings/security'
    | '/settings/users'
    | '/user/user-profile'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/payments/domestic/$id'
    | '/payments/foreign/$id'
    | '/payments/pairing/$id'
    | '/payments/sepa/$id'
    | '/settings/users/$id'
    | '/settings/users/new'
    | '/payments/domestic'
    | '/payments/foreign'
    | '/payments/pairing'
    | '/payments/sepa'
    | '/settings/accounts'
    | '/settings/banks'
    | '/settings/security'
    | '/settings/users'
    | '/user/user-profile'
  id:
    | '__root__'
    | '/'
    | '/payments/domestic/$id'
    | '/payments/foreign/$id'
    | '/payments/pairing/$id'
    | '/payments/sepa/$id'
    | '/settings/users/$id'
    | '/settings/users/new'
    | '/payments/domestic/'
    | '/payments/foreign/'
    | '/payments/pairing/'
    | '/payments/sepa/'
    | '/settings/accounts/'
    | '/settings/banks/'
    | '/settings/security/'
    | '/settings/users/'
    | '/user/user-profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PaymentsDomesticIdRoute: typeof PaymentsDomesticIdRoute
  PaymentsForeignIdRoute: typeof PaymentsForeignIdRoute
  PaymentsPairingIdRoute: typeof PaymentsPairingIdRoute
  PaymentsSepaIdRoute: typeof PaymentsSepaIdRoute
  SettingsUsersIdRoute: typeof SettingsUsersIdRoute
  SettingsUsersNewRoute: typeof SettingsUsersNewRoute
  PaymentsDomesticIndexRoute: typeof PaymentsDomesticIndexRoute
  PaymentsForeignIndexRoute: typeof PaymentsForeignIndexRoute
  PaymentsPairingIndexRoute: typeof PaymentsPairingIndexRoute
  PaymentsSepaIndexRoute: typeof PaymentsSepaIndexRoute
  SettingsAccountsIndexRoute: typeof SettingsAccountsIndexRoute
  SettingsBanksIndexRoute: typeof SettingsBanksIndexRoute
  SettingsSecurityIndexRoute: typeof SettingsSecurityIndexRoute
  SettingsUsersIndexRoute: typeof SettingsUsersIndexRoute
  UserUserProfileIndexRoute: typeof UserUserProfileIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/user-profile/': {
      id: '/user/user-profile/'
      path: '/user/user-profile'
      fullPath: '/user/user-profile'
      preLoaderRoute: typeof UserUserProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/users/': {
      id: '/settings/users/'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/security/': {
      id: '/settings/security/'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/banks/': {
      id: '/settings/banks/'
      path: '/settings/banks'
      fullPath: '/settings/banks'
      preLoaderRoute: typeof SettingsBanksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/accounts/': {
      id: '/settings/accounts/'
      path: '/settings/accounts'
      fullPath: '/settings/accounts'
      preLoaderRoute: typeof SettingsAccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/sepa/': {
      id: '/payments/sepa/'
      path: '/payments/sepa'
      fullPath: '/payments/sepa'
      preLoaderRoute: typeof PaymentsSepaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/pairing/': {
      id: '/payments/pairing/'
      path: '/payments/pairing'
      fullPath: '/payments/pairing'
      preLoaderRoute: typeof PaymentsPairingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/foreign/': {
      id: '/payments/foreign/'
      path: '/payments/foreign'
      fullPath: '/payments/foreign'
      preLoaderRoute: typeof PaymentsForeignIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/domestic/': {
      id: '/payments/domestic/'
      path: '/payments/domestic'
      fullPath: '/payments/domestic'
      preLoaderRoute: typeof PaymentsDomesticIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/users/new': {
      id: '/settings/users/new'
      path: '/settings/users/new'
      fullPath: '/settings/users/new'
      preLoaderRoute: typeof SettingsUsersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/users/$id': {
      id: '/settings/users/$id'
      path: '/settings/users/$id'
      fullPath: '/settings/users/$id'
      preLoaderRoute: typeof SettingsUsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/sepa/$id': {
      id: '/payments/sepa/$id'
      path: '/payments/sepa/$id'
      fullPath: '/payments/sepa/$id'
      preLoaderRoute: typeof PaymentsSepaIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/pairing/$id': {
      id: '/payments/pairing/$id'
      path: '/payments/pairing/$id'
      fullPath: '/payments/pairing/$id'
      preLoaderRoute: typeof PaymentsPairingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/foreign/$id': {
      id: '/payments/foreign/$id'
      path: '/payments/foreign/$id'
      fullPath: '/payments/foreign/$id'
      preLoaderRoute: typeof PaymentsForeignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/domestic/$id': {
      id: '/payments/domestic/$id'
      path: '/payments/domestic/$id'
      fullPath: '/payments/domestic/$id'
      preLoaderRoute: typeof PaymentsDomesticIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PaymentsDomesticIdRoute: PaymentsDomesticIdRoute,
  PaymentsForeignIdRoute: PaymentsForeignIdRoute,
  PaymentsPairingIdRoute: PaymentsPairingIdRoute,
  PaymentsSepaIdRoute: PaymentsSepaIdRoute,
  SettingsUsersIdRoute: SettingsUsersIdRoute,
  SettingsUsersNewRoute: SettingsUsersNewRoute,
  PaymentsDomesticIndexRoute: PaymentsDomesticIndexRoute,
  PaymentsForeignIndexRoute: PaymentsForeignIndexRoute,
  PaymentsPairingIndexRoute: PaymentsPairingIndexRoute,
  PaymentsSepaIndexRoute: PaymentsSepaIndexRoute,
  SettingsAccountsIndexRoute: SettingsAccountsIndexRoute,
  SettingsBanksIndexRoute: SettingsBanksIndexRoute,
  SettingsSecurityIndexRoute: SettingsSecurityIndexRoute,
  SettingsUsersIndexRoute: SettingsUsersIndexRoute,
  UserUserProfileIndexRoute: UserUserProfileIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
